import { useEffect, useState } from "react"
import { DefaultDataGridReport } from "../components/DefaultDataGrid"
import { DefaultPaperReport } from "../components/DefaultPaper"
import { calculateTimeRange } from "../../../utils/timeUtils"
import { IReportMetricsItem, IReportMetricsRow, IReportMetricsTotal } from "../../../@types/reports-metrics.type"
import { getAreasMetrics } from "../../../services/api/areas/AreasService"
import { SelectedType } from './../index'

const createInitialMetricsTotal = (): IReportMetricsTotal => {
  return {
    totalScheduled: '-',
    totalBillable: '-',
    totalNonBillable: '-',
    totalScheduledPercentage: 0,
    totalBillablePercentage: 0,
    totalNonBillablePercentage: 0,
  };
};

export const ReportAreas: React.FC<{ 
  filterState: any;
  selectedType: SelectedType | null;
  setRowSelected: React.Dispatch<
    React.SetStateAction<IReportMetricsRow | null>>;
  setSelectedType: React.Dispatch<
    React.SetStateAction<SelectedType | null>>;
  setValueTab: React.Dispatch<
    React.SetStateAction<number>>;
  valueTab: number;
   }> = ({
filterState, selectedType, setRowSelected, setSelectedType, setValueTab, valueTab,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [areasMetrics, setAreasMetrics] = useState<IReportMetricsItem[]>([]);
  const [areasMetricsRows, setAreasMetricsRows] = useState<IReportMetricsRow[]>([]);
  const [areasMetricsTotal, setAreasMetricsTotal] = useState<IReportMetricsTotal>(createInitialMetricsTotal);
  const [totalRows, setTotalRows] = useState(0);

  async function fetchAllAreasMetrics() {
    try {
      setLoading(true);
      const { startDate, endDate } = calculateTimeRange(filterState.currentPeriod, filterState.period);
      const startTime = startDate.startOf("day").toISOString();
      const endTime = endDate.startOf("day").toISOString();
      const response = (await getAreasMetrics({
        startTime: startTime,
        endTime: endTime,
        timeType: filterState.timeMode
      }));
      setTotalRows(response.result.metric.length);
      setAreasMetrics(response.result.metric);
      setAreasMetricsTotal({
        totalScheduled: filterState.timeMode === 1
          ? `${response.result.totalScheduled.toLocaleString() || 0}h`
          : `${response.result.totalScheduled.toLocaleString() || 0}d`,
        totalBillable: filterState.timeMode === 1
          ? `${response.result.totalBillable.toLocaleString() || 0}h`
          : `${response.result.totalBillable.toLocaleString() || 0}d`,
        totalNonBillable: filterState.timeMode === 1
          ? `${response.result.totalNonBillable.toLocaleString() || 0}h`
          : `${response.result.totalNonBillable.toLocaleString() || 0}d`,
        totalScheduledPercentage: response.result.totalScheduledPercentage != null
          ? Number(response.result.totalScheduledPercentage.toFixed(2))
          : 0,
        totalBillablePercentage: response.result.totalBillablePercentage != null
          ? Number(response.result.totalBillablePercentage.toFixed(2))
          : 0,
        totalNonBillablePercentage: response.result.totalNonBillablePercentage != null
          ? Number(response.result.totalNonBillablePercentage.toFixed(2))
          : 0
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAllAreasMetrics();
    setSelectedType("area");
  }, [filterState]);

  const transformMetricsToRows = (metrics: IReportMetricsItem[]): IReportMetricsRow[] => {
    return metrics.map((item) => ({
      id: item.id,
      name: item.name,
      totalScheduled: filterState.timeMode === 1 ? `${item.scheduled}h` : `${item.scheduled}d`,
      percentScheduled: item.scheduledPercentage,
      billed: filterState.timeMode === 1 ? `${item.billable}h` : `${item.billable}d`,
      notBilled: filterState.timeMode === 1 ? `${item.nonBillable}h` : `${item.nonBillable}d`,
      contractedHours: filterState.timeMode === 1 ? `${item.contracted ?? 0}h` : `${item.contracted ?? 0}d`,
    }));
  };

  useEffect(() => {
    const transformedRows = transformMetricsToRows(areasMetrics);
    setAreasMetricsRows(transformedRows);
  }, [areasMetrics]);

  return (
    <>
      <DefaultPaperReport
        scheduledData={String(areasMetricsTotal?.totalScheduled)}
        billedData={String(areasMetricsTotal?.totalBillable)}
        billedPercentData={areasMetricsTotal?.totalBillablePercentage}
        notBilledData={String(areasMetricsTotal?.totalNonBillable)}
        notBilledPercentData={areasMetricsTotal?.totalNonBillablePercentage}
        filterState={filterState}
      />
      <DefaultDataGridReport
        columnName="Área"
        rows={areasMetricsRows}
        rowCount={totalRows}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        setRowSelected={setRowSelected}
        setValueTab={setValueTab}
        valueTab={valueTab}
        filterState={filterState}
      />
    </>
  );
};